var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutForm",
    [
      _c("h1", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Edit Member"),
      ]),
      _vm._v(" "),
      _c("MemberFormStep1", { attrs: { type: "edit" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }